import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useLocation} from "react-router";
import {updateGameStatus} from "../../../store/player/actions";
import {selectIsInGame, selectPlayer} from "../../../store/player/selectors";
import {selectIsLoggedIn, selectSessionUser} from "../../../store/authentication/selectors";
import * as io from "socket.io-client";
import axios from "axios";
import constants from "../../../config/constants";
import useTheme from "@mui/material/styles/useTheme";
import "./BoardGamePage.css";
import Box from "@mui/material/Box";
import {Paper} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Button from "@mui/material/Button";
import {GamesSnippet} from "../games-snippet/GamesSnippet";


const getProperDate = (score) => {
    let date = "";
    date += (score.day < 10 ? "0" : "") + score.day + "/";
    date += (score.month < 10 ? "0" : "") + (score.month) + "/";
    date += (score.year % 1000);
    return date;
}


export const BoardGamePage = () => {


    const history = useHistory();
    const dispatch = useDispatch();

    const player = useSelector(selectPlayer);
    const [ladder, setLadder] = useState([]);

    const user = useSelector(selectSessionUser);

    let mobile = window.innerWidth < 700;
    const scores = player.games ? player.games : [];

    function handleSeePreviousGameDetails(game) {
        let path = "/board-games/previous-game/" + game.gamekey + "/" + game.gameId;
        history.push(path);
    }

    useEffect(() => {
        axios.get(constants.api.basePath + "/ladder/terraformingMars").then(data => {
            setLadder(data.data.results);
        });
    }, []);

    useEffect(() => {
        if (user) {
            dispatch(updateGameStatus(user));
        }
    }, [user]);


    const links = <div className={"button-holders"} style={{marginBottom: mobile ? "5vh" : "5vh"}}>
        <a className={"button-holder"}
           style={{
               width: mobile ? "40vw" : "20vw",
               height: mobile ? "15vh" : "35vh",
               textAlign: "center"
           }}
           href="https://welcomegames.fr/downloads/WelcomeGames.dmg" download>
            <img src={"../../public/devices/link_apple.png"} alt={"apple store link"}/>
            Macos Launcher
        </a>
        <a className={"button-holder"}
           style={{
               width: mobile ? "40vw" : "20vw",
               height: mobile ? "15vh" : "35vh",
               textAlign: "center"
           }}
           href="https://welcomegames.fr/downloads/WelcomeGames.msi" download>
            <img src={"../../public/devices/link_windows.png"} alt={"google play link"}/>
            Windows Launcher
        </a>
    </div>;


    return (
        <Box sx={{width: {xs: "80%", md: "50%", lg: "33%"}}} style={{margin: "3vh auto"}}>
            <GamesSnippet displayEvenIfEmpty={true}/>
            <div style={{marginBottom: "3vh"}}>
                <h2>
                    Download Launcher
                </h2>
            </div>
            {links}
            <div style={{marginBottom: '5vh'}}>
                <div>
                    <h2>
                        Terraforming Mars Ladder
                    </h2>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead style={{display: "block"}}>
                                <TableRow style={{width: "100%", display: "flex"}}>
                                    <TableCell style={{width: "40%"}}>Player</TableCell>
                                    <TableCell style={{width: "20%"}}>ELO</TableCell>
                                    <TableCell style={{width: "20%"}}>Rank</TableCell>
                                    <TableCell style={{width: "20%"}}>Games</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody className="bodyPreviousGames"
                                       style={{
                                           display: "block",
                                           height: "50vh",
                                           overflowX: "hidden",
                                           overflowY: "scroll"
                                       }}>
                                {
                                    ladder.length ?
                                        ladder.map((ladder, index) => (
                                            <TableRow key={ladder._id} style={{width: "100%", display: "flex"}}>
                                                <TableCell className="col-xs-4"
                                                           style={{
                                                               "verticalAlign": "middle",
                                                               width: "40%"
                                                           }}>{ladder.username}</TableCell>
                                                <TableCell className="col-xs-2"
                                                           style={{
                                                               "verticalAlign": "middle",
                                                               width: "20%"
                                                           }}>{Math.floor(ladder.ELO)}</TableCell>
                                                <TableCell className="col-xs-2"
                                                           style={{
                                                               "verticalAlign": "middle",
                                                               width: "20%"
                                                           }}>{index + 1}</TableCell>
                                                <TableCell className="col-xs-2"
                                                           style={{
                                                               "verticalAlign": "middle",
                                                               width: "20%"
                                                           }}>{ladder.nbGame}</TableCell>
                                            </TableRow>
                                        )) :
                                        <TableRow>
                                            <TableCell colSpan="4" style={{"verticalAlign": "middle"}}>
                                                No ladder yet
                                            </TableCell>
                                        </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
            <div style={{marginBottom: '5vh'}}>
                <div>
                    <h2>
                        Terraforming Mars Statistics
                    </h2>
                </div>
                <div style={{width: "100%", textAlign: "center", margin: "3vh 0"}}>
                    <Button onClick={() => history.push("/board-games/terraforming-mars/stats")} variant="contained">
                        Stats
                    </Button>
                </div>
            </div>
        </Box>
    )
};


export default BoardGamePage;
